<footer class="footer">
    <div class="container h-100" style="padding: 20px 0px;">
        <div class="row align-items-center h-100">
            <div class="col-12 col-sm-6 mx-auto" style="text-align:center;font-size:15px; font-family: 'Montserrat';">
                Copyright © Eton College Ltd. 2022. All Rights Reserved.
            </div>
        </div>
    </div>
</footer>